import React, { Component } from "react";
// import Timeline from 'react-timelines'
// import 'react-timelines/lib/css/style.css'

import "./index.css";
import "./styles.css";

import { START_YEAR, NUM_OF_YEARS } from "./constants";
import { buildTimebar, generarDatosJson } from "./builders";

import Timeline from "../src";
import datos from "./data.json";

const now = new Date();

const timebar = buildTimebar();

// console.log("timebar", timebar)

const clickElement = (element) => {
  //alert(`Clicked element\n${JSON.stringify(element, null, 2)}`);
}

const MIN_ZOOM = 20;
const MAX_ZOOM = 40;

class PlanDeMediosIntegradoTimeline extends Component {
  constructor(props) {
    super(props);

    this.state = {
      open: true,
      zoom: 40,
      // eslint-disable-next-line react/no-unused-state
      tracksGenerados: this.props.datosDelFiltro //generarDatosJson(datos.data),
    };
  }

  handleToggleOpen = () => {
    this.setState(({ open }) => ({ open: !open }));
  };

  handleZoomIn = () => {
    this.setState(({ zoom }) => ({ zoom: Math.min(zoom + 1, MAX_ZOOM) }));
  };

  handleZoomOut = () => {
    this.setState(({ zoom }) => ({ zoom: Math.max(zoom - 1, MIN_ZOOM) }));
  };

  handleToggleTrackOpen = (track) => {
    const {subListItem, idCobertura, idEmpresa, idMedio} = track

    if(subListItem == "cobertura") {
      return this.setState((state) => {
          return {
            tracksGenerados: state.tracksGenerados.map((item) =>
              item.id === track.id ? { ...item, isOpen: !track.isOpen } : item
            ),
          };
      });
    }

    if(subListItem == "empresa") {
      this.setState((state) => ({
        tracksGenerados: state.tracksGenerados.map((item) =>
          item.idCobertura === idCobertura
          ? {...item,
              tracks: item.tracks.map((item2) => item2.idComparar === track.idComparar
                      ? {...item2, isOpen: !item2.isOpen } : item2
            )
          }
          : item
        )
      }));
    }

    if(subListItem == "medio") {
      this.setState((state) => ({
        tracksGenerados: state.tracksGenerados.map((item) =>
          item.idCobertura === idCobertura
          ? {...item,
              tracks: item.tracks.map((item2) =>
                      item2.idComparar === track.idEmpresa
                      ? {...item2,
                          tracks: item2.tracks.map( item3 => item3.idComparar === track.idComparar
                            ? { ...item3, isOpen: !item3.isOpen}
                            : item3)
                        } : item2
            )
          }
          : item
        )
      }));
    }

    if(subListItem == "eleccion") {
      this.setState((state) => ({
        tracksGenerados: state.tracksGenerados.map((item) =>
          item.idCobertura === idCobertura
          ? {...item,
              tracks: item.tracks.map((item2) =>
                      item2.idComparar === track.idEmpresa
                      ? {...item2,
                          tracks: item2.tracks.map( item3 =>
                            item3.idComparar === track.idMedio
                            ? {...item3,
                              tracks: item3.tracks.map ( item4 =>
                                item4.idComparar == track.idComparar
                                  ? { ...item4, isOpen: !item4.isOpen} : item4
                                )}
                            : item3
                            )
                        }
                      : item2
            )
          }
          : item
        )
      }));
    }
  };

  render() {
    const { open, zoom, tracksGenerados } = this.state;
    const start = new Date(`${START_YEAR}`);
    const end = new Date(`${START_YEAR + NUM_OF_YEARS}`);
    return (
      <div className="app">
        <Timeline
          scale={{
            start,
            end,
            zoom,
            zoomMin: MIN_ZOOM,
            zoomMax: MAX_ZOOM,
          }}
          isOpen={open}
          toggleOpen={this.handleToggleOpen}
          zoomIn={this.handleZoomIn}
          zoomOut={this.handleZoomOut}
          clickElement={clickElement}
          clickTrackButton={(track) => {
            // eslint-disable-next-line no-alert
            // alert(JSON.stringify(track));
          }}
          timebar={timebar}
          tracks={tracksGenerados}
          // tracks={this.props.datosDelFiltro}
          now={now}
          toggleTrackOpen={this.handleToggleTrackOpen}
          enableSticky
          scrollToNow
        />
      </div>
    );
  }
}

export default PlanDeMediosIntegradoTimeline;
